import { ColDef, SuppressKeyboardEventParams } from '@ag-grid-community/core';

import { getPercent, getPercentColor, suppresskeyboardEventForEnter } from '../shared/utils';
import { OmTabStatsResponse, DatasheetTabStatsResponse } from '../queries/apiTypes';

export const getStats = (data: OmTabStatsResponse | undefined, datasheetData: DatasheetTabStatsResponse | undefined) => {
    if (data && datasheetData) {
        const { selected_instalation_guide, selected_installation_drawing, selected_warranty, selected_other_documents, hidden_product, total } = data;
        const { selected_datasheet, hidden_product: hiddenDatasheets, total: totalDatasheet } = datasheetData;
        const totalValid = total - hidden_product;
        const totalValidDatasheet = totalDatasheet - hiddenDatasheets;
        return [
            {
                title: 'DATASHEETS SELECTED',
                count: `${selected_datasheet} of ${totalValidDatasheet}`,
                helperTextColor: getPercentColor(getPercent(selected_datasheet, totalValid))
            },
            {
                title: 'INSTAL. GUIDES SELECTED',
                count: `${selected_instalation_guide} of ${totalValid}`,
                helperTextColor: getPercentColor(getPercent(selected_instalation_guide, totalValid))
            },
            {
                title: 'DRAWINGS SELECTED',
                count: `${selected_installation_drawing} of ${totalValid}`,
                helperTextColor: getPercentColor(getPercent(selected_installation_drawing, totalValid))
            },
            {
                title: 'WRTY. SELECTED',
                count: `${selected_warranty} of ${totalValid}`,
                helperTextColor: getPercentColor(getPercent(selected_warranty, totalValid))
            },
            {
                title: 'ADD. DOCS SELECTED',
                count: `${selected_other_documents} of ${totalValid}`,
                helperTextColor: getPercentColor(getPercent(selected_other_documents, totalValid))
            }
        ];
    }
    return [];
};

export const toolBarOptions = ['createSection', 'delete', 'search', 'hide', 'selectedItems', 'duplicate', 'move', 'createKit', 'highlight', 'bulkEdit'];
export const BULK_EDIT_OPTIONS = ['qty', 'qtyPer', 'manufacturer'];

export const getOmLoadTime = (selectedItems: any[]) => {
    const loadTime = 1000; //time for one bod in milliseconds;
    const validBods = selectedItems.filter(
        (item: any) => item?.selected_warranty?.document_selection_status !== 'CONFIRMED' || item?.selected_installation_guide?.document_selection_status !== 'CONFIRMED'
    );
    return validBods.length * loadTime + 270; //270 milliseconds is the static time for api calling
};

export const defaultColDef: ColDef = {
    sortable: false,
    menuTabs: [],
    resizable: true,
    suppressFillHandle: true,
    suppressKeyboardEvent: (params: SuppressKeyboardEventParams) => {
        if (params.event.key === 'Enter') return suppresskeyboardEventForEnter(params);
        return false;
    }
};

// export const getIsTableDataUpdated = <T extends BodResponse & OmDataResponse & DatasheetTabDataResponse>(apiTableData: T[], localTableData: T[]) => {
//     return apiTableData.some((productData, index) => {
//         return (
//             productData?.is_hidden !== localTableData?.[index]?.is_hidden ||
//             productData?.is_highlighted !== localTableData?.[index]?.is_highlighted ||
//             productData?.manufacturer !== localTableData?.[index]?.manufacturer ||
//             productData?.qty !== localTableData?.[index]?.qty ||
//             productData?.category !== localTableData?.[index]?.category ||
//             productData?.model_number !== localTableData?.[index]?.model_number ||
//             !isEqual(productData.selected_datasheet, localTableData[index].selected_datasheet) ||
//             !isEqual(productData.selected_drawing, localTableData[index].selected_drawing) ||
//             !isEqual(productData.selected_installation_guide, localTableData[index].selected_installation_guide) ||
//             !isEqual(productData.selected_other_document, localTableData[index].selected_other_document) ||
//             !isEqual(productData.selected_warranty, localTableData[index].selected_warranty) ||
//             productData?.is_kit !== localTableData[index]?.is_kit ||
//             !isEqual(productData?.groupPath, localTableData?.[index]?.groupPath)
//         );
//     });
// };
